var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.newReservations !== 0)?_c('v-chip',{attrs:{"color":"red","text-color":"white","small":""}},[_vm._v(_vm._s(_vm.newReservations))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }